import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { Edit, Save } from "@mui/icons-material";

export const FeedbackEditorTextfield = ({
  label,
  helperText,
  value,
  lastSavedValue,
  onChange,
  onSave,
  rows = 5,
  readOnly = false,
}) => {
  const [editing, setEditing] = useState(false);

  const handleSaveChange = () => {
    setEditing(false);
    if (value !== lastSavedValue) {
      onSave();
    }
  };

  return (
    <Box sx={{ width: "100%", py: 2 }}>
      {readOnly ? (
        <Box
          sx={{
            height: "100%",
            p: { xs: 2, md: 3 },
            borderRadius: 2,
            bgcolor: "action.hover",
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight={700}
            color="primary.main"
            sx={{ mb: 1.5 }}
          >
            {label}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.7,
              color: value ? "text.primary" : "text.secondary",
            }}
          >
            {value || "No feedback provided."}
          </Typography>
        </Box>
      ) : (
        <TextField
          label={label}
          multiline
          rows={rows}
          variant="outlined"
          fullWidth
          value={value}
          helperText={!value && !readOnly && helperText}
          disabled={!editing}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
      {!readOnly && (
        <Box sx={{ mt: 1 }}>
          <Button
            variant="card-action"
            color="primary"
            onClick={() => {
              editing ? handleSaveChange() : setEditing(true);
            }}
            startIcon={editing ? <Save /> : <Edit />}
          >
            {editing ? "Save" : "Edit"}
          </Button>
        </Box>
      )}
    </Box>
  );
};
